import React, {Component} from 'react';
import {Row, Col, Card, CardHeader, CardBody, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import Widget01 from './items/Widget01'
import Widget02 from './items/Widget02'
import { getDeviceData } from '../../../utils/deviceAPI';
import LoadingIndicator from '../../../utils/LoadingIndicator'
import {Bar, Line} from "react-chartjs-2";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import DeviceOffline from '../DeviceMessages/DeviceOffline';
import {isDeviceOnline} from "../../../utils/isDeviceOnline";
function getTimeFromSeconds (seconds) {
    let d = Number(seconds);

    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);
    return ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
}
const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

//google maps

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
    <GoogleMap
        defaultZoom={12}
        defaultCenter={{ lat: 35.7299452, lng: -78.9284863 }}
    >
        <Marker position={{ lat: 35.7299452, lng: -78.9284863 }} />

    </GoogleMap>
));

// Card Chart 2
const cardChartData2 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: brandInfo,
            borderColor: 'rgba(255,255,255,.55)',
            data: [1, 18, 9, 17, 34, 22, 11]
        }
    ],
};

const cardChartOpts2 = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
            },
            ticks: {
                fontSize: 2,
                fontColor: 'transparent',
            }

        }],
        yAxes: [{
            display: false,
            ticks: {
                display: false,
                min: Math.min.apply(Math, cardChartData2.datasets[0].data) - 5,
                max: Math.max.apply(Math, cardChartData2.datasets[0].data) + 5,
            }
        }],
    },
    elements: {
        line: {
            tension: 0.00001,
            borderWidth: 1
        },
        point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4,
        },
    }
}
const AnyReactComponent = ({ text }) => <div>{text}</div>;
class Sites extends Component {
    constructor() {
        super();
        this.state = { data: [
            {

                initializer: 0,
            },
            {
                initializer: 0,
            }

        ],
            loading: true
        };
    }
    componentDidMount() {
        this.tick();
        this.timerID = setInterval(
            () => this.tick(),
            5000
        );
    }
    componentWillReceiveProps(nextProps) {
        const dev = this.props.match.params.dev.replace('device_','');
        const newDev = nextProps.match.params.dev.replace('device_','');
        if (dev !== newDev ) {
            this.tick(newDev);
        }
    }

    componentWillUnmount(){
        clearInterval(this.timerID);
    }
    tick(device = this.props.match.params.dev.replace('device_','')) {

        //const params = new URLSearchParams(this.props.location.search);
        //const dev = params.get('dev'); // bar

        getDeviceData(device).then((data) => {
            this.setState({
                data,
                loading: false
            });

        }).catch((error) => {
            this.props.history.replace('/login');

        });
    }

    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        if (!isDeviceOnline(this.props.uidata.alarms,this.props.match.params.dev.replace('device_',''))) {
            return (
                <DeviceOffline/>
            )
        }
        const { data } = this.state;
        const iodb  = data[0];
        const deviceInfo  = data[1];
        const ethernetConfigs = deviceInfo['intInfo'].split(';');
        const upTime = getTimeFromSeconds(deviceInfo.upTime);

        return (
            <div className="containerAnimation">
                <div className="fadeInUp">
                <Row>
                    <Col xs="12" sm="6" lg="3">
                        <Widget01 icon="fa fa-bar-chart" color="primary" header={iodb.CPU_Load + ' %'} value={iodb.CPU_Load + ''}>Current CPU Load</Widget01>
                    </Col>
                    <Col xs="12" sm="6" lg="3">
                        <Widget02 icon="fa fa-th-large" color="primary" header={deviceInfo.model} value="0">Model</Widget02>
                    </Col>
                    <Col xs="12" sm="6" lg="6">
                        <Widget02 icon="fa fa-barcode" header={deviceInfo.serialNumber} >Serial</Widget02>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" lg="12">
                        <Card>
                            <CardHeader>
                                Cell Signal
                            </CardHeader>
                            <CardBody className="card-body">
                                <Table responsive>
                                    <tbody>
                                    <tr>
                                        <td>Cell Channel</td>
                                        <td>{deviceInfo.cellChan}</td>
                                    </tr>
                                    <tr>
                                        <td>rssi</td>
                                        <td>{deviceInfo.rssi}</td>
                                    </tr>
                                    <tr>
                                        <td>ecio</td>
                                        <td>{deviceInfo.ecio}</td>
                                    </tr>
                                    <tr>
                                        <td>rsrp</td>
                                        <td>{deviceInfo.rsrp}</td>
                                    </tr>
                                    <tr>
                                        <td>rsrq</td>
                                        <td>{deviceInfo.rsrq}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" lg="6">
                        <Card>
                            <CardHeader>
                                Cell Information
                            </CardHeader>
                            <CardBody className="card-body">
                                <Table responsive>
                                    <tbody>
                                    <tr>
                                        <td>Cell Service</td>
                                        <td>{deviceInfo.cellServType}</td>
                                    </tr>
                                    <tr>
                                        <td>Uptime</td>
                                        <td>{upTime}</td>
                                    </tr>
                                    <tr>
                                        <td>IMEI</td>
                                        <td>{deviceInfo.imei}</td>
                                    </tr>
                                    <tr>
                                        <td>MDN</td>
                                        <td>{deviceInfo.mdn}</td>
                                    </tr>
                                    <tr>
                                        <td>SIM ID</td>
                                        <td>{deviceInfo.simID}</td>
                                    </tr>
                                    <tr>
                                        <td>APN</td>
                                        <td>{deviceInfo.apn}</td>
                                    </tr>
                                    <tr>
                                        <td>IMEI</td>
                                        <td>{deviceInfo.imei}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs="12" lg="6">
                        <Card>
                            <CardHeader>
                                Device Information
                            </CardHeader>
                            <CardBody className="card-body">
                                <Table responsive>
                                    <tbody>
                                    <tr>
                                        <td>Uptime</td>
                                        <td>{upTime}</td>
                                    </tr>
                                    <tr>
                                        <td>Version</td>
                                        <td>{deviceInfo.versionLong}</td>
                                    </tr>
                                    <tr>
                                        <td>Host Name</td>
                                        <td>{deviceInfo.hostName}</td>
                                    </tr>
                                    <tr>
                                        <td>Model</td>
                                        <td>{deviceInfo.model}</td>
                                    </tr>
                                    <tr>
                                        <td>Model</td>
                                        <td>{deviceInfo.serialNumber}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" lg="12">
                        <Card>
                            <CardHeader>
                                Network Information
                            </CardHeader>
                            <CardBody className="card-body">
                                <Table responsive>
                                    <tbody>
                                    <tr>
                                        <td>Ethernet</td>
                                        <td>{deviceInfo.intInfo}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </div>
            </div>

        )
    }
}

export default Sites;



// WEBPACK FOOTER //
// ./src/views/site/information/DeviceInformation.js